















































































































































import { Component, Vue } from 'vue-property-decorator';
import axios, { AxiosResponse } from 'axios';
import moment, { Moment } from 'moment';
import storage from 'baimahu/storage';
const profile = storage.getItem('profile') || {};
const merchant_id = profile.merchant_id || '';
const { VUE_APP_FCAPI: FCAPI, VUE_APP_FCREST: FCREST } = process.env;

const uuidv4 = require('uuid/v4');
const clean = require('bmh/clean-empty-obj');
const API = {
  activity: `${FCREST}/promotion/shang/statement/activity`, // 获取活动信息
  is_show: `${FCREST}/promotion/shang/activity`, // 上下架
  get_setting_info: `${FCAPI}/shang/setting/profile/${merchant_id}`,
  qrcode: `${FCAPI}/shang/activity/preview`,
};
const dateFormat = require('bmh/date-format');
function getActivityData(remote?: any) {
  remote = remote || {};
  return {
    activity_id: remote.id || 0,
    activity_name: remote.name || '',
    activity_type: remote.activity_type || 0,
    activity_start_time: remote.start_time || 0,
    activity_status: remote.status || '',
    is_show: remote.is_show || '',
    live_room_id: remote.live_room_id || '',
    apply_integral: remote.apply_integral || 0,
    commodity_integral: remote.commodity_integral || 0,
    page_view_integral: remote.page_view_integral || 0,
    slideshow: remote.slideshow ? remote.slideshow.split(',') : [],
    first_level_target: remote.first_level_target || '',
    second_level_target: remote.second_level_target || '',
    is_specify_ware_set: remote.is_specify_ware_set || 0,
  };
}

// 订单类型
const ORDER_TYPE = {
  normal: 1, // 普通活动订单，
  live: 2, // 直播订单
};

const MODULE_NAME = {
  activity_config: 1,
  master_data: 2,
  other_data: 3,
};

// 活动配置模块
function getActivityItemList(module_type: number, data?: any) {
  if (module_type === 1) {
    return [
      {
        value: '指定商品',
        url: '/activity/activity-ware',
        is_need_activity_id: true,
        operate: data && data.is_specify_ware_set === 1 ? '已设置' : '未设置',
      },
      {
        value: '目标',
        url: '/activity/activity-target',
        is_need_activity_id: true,
        operate:
          data && (data.first_level_target || data.second_level_target)
            ? '已设置'
            : '未设置',
      },
      {
        value: '积分',
        url: '/activity/activity-integration',
        is_need_activity_id: true,
        operate:
          data &&
          data.page_view_integral +
            data.apply_integral +
            data.commodity_integral >
            3
            ? '已设置'
            : '未设置',
      },
    ];
  }
  if (module_type === 2) {
    return [
      {
        value: '积分排名',
        url: '/activity/activity-integration-rank',
        is_need_activity_id: true,
        operate: '查看详情',
      },
      {
        value: '浏览排名',
        url: '/activity/browse',
        is_need_activity_id: true,
        operate: '查看详情',
      },
      {
        value: '报名排名',
        url: '/activity/sign-up',
        is_need_activity_id: true,
        operate: '查看详情',
      },
      {
        value: '指定商品排名',
        url: '/activity/activity-ware-rank',
        is_need_activity_id: true,
        operate: '查看详情',
      },
      {
        value: '详细数据',
        url: '/activity/details',
        is_need_activity_id: true,
        operate: '查看详情',
      },
    ];
  }
  if (module_type === 3) {
    return [
      {
        value: '奖励金额',
        url: '/activity/award',
        is_need_activity_id: true,
        operate: '查看详情',
      },
      {
        value: '活动订单',
        url: '/order/list',
        is_need_activity_id: true,
        order_type: ORDER_TYPE.normal,
        operate: '查看详情',
      },
      {
        value: '直播观看情况',
        url: '/activity/watch',
        is_need_activity_id: true,
        operate: '查看详情',
      },
      {
        value: '直播订单',
        url: '/order/list',
        is_need_activity_id: true,
        order_type: ORDER_TYPE.live,
        operate: '查看详情',
      },
      {
        value: '带单情况',
        url: '/activity/bring-order',
        is_need_activity_id: true,
        order_type: ORDER_TYPE.live,
        operate: '查看详情',
      },
    ];
  }
}
@Component
export default class ActivityPage extends Vue {
  activity_id: string = ''; // 活动id
  activity_info: any = getActivityData(); // 活动信息
  activity_item_list: any = getActivityItemList(
    this.moduleName.activity_config,
  );
  is_loading: boolean = false;
  is_show_qr_code: boolean = false; // 是否展示‘预览’模态窗
  qrcode_url: string = ''; // ‘预览模态窗’图片地址
  master_item_list: any = getActivityItemList(this.moduleName.master_data);
  other_item_list: any = getActivityItemList(this.moduleName.other_data);
  get moduleName() {
    return MODULE_NAME;
  }
  dateFormat(time: any) {
    return dateFormat(new Date(time * 1000), '%Y-%m-%d %H:%M:%S');
  }

  // 点击不同模块跳转页面
  toOtherPage(item: any) {
    const send_data: any = {};
    send_data.order_type = item.order_type === 1 ? item.order_type : '';
    send_data.room_id =
      item.order_type && item.order_type !== 1
        ? this.activity_info.live_room_id
        : '';
    send_data.activity_id = this.activity_id;
    this.$router.push({
      path: item.url,
      query: send_data,
    });
  }

  // 点击预览
  async getAppIdAndQrcode() {
    this.is_loading = true;
    const send_data = {
      scene: `${this.activity_id}`,
      page: 'pages/live/promotion/activity/main',
      width: 280,
    };
    const qrcode_res = await this.$axios.get(
      `${API.qrcode}/${this.activity_id}`,
      {
        params: send_data,
      },
    );
    this.is_loading = false;
    if (qrcode_res.status !== 200) {
      this.$message.error(qrcode_res.data.message);
      return;
    }
    this.qrcode_url = qrcode_res.data.data;
    this.is_show_qr_code = true;
  }

  // 上下架
  confirmSwitchOnlineStatus() {
    this.$confirm({
      title: `确认${this.activity_info.is_show === 1 ? '下架' : '上架'}？`,
      onOk: async () => {
        const res = await this.$axios.get(
          `${API.is_show}/${this.activity_id}/edit?is_show=${
            this.activity_info.is_show === 1 ? 2 : 1
          }`,
        );
        if (res.status !== 200) {
          this.$message.error(res.data.message);
          return;
        }
        const _message =
          this.activity_info.is_show === 1 ? '下架成功' : '上架成功';
        this.$message.success(_message);
        this.activity_info.is_show = this.activity_info.is_show === 1 ? 2 : 1;
      },
    });
  }

  // 获取活动数据
  async query() {
    this.is_loading = true;
    const res = await this.$axios.get(
      `${API.activity}?activity_id=${this.activity_id}`,
    );
    this.is_loading = false;
    this.activity_info = getActivityData();
    if (res.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    const now_timestamp = ~~(+new Date() / 1000);
    res.data.data.activity_info.status =
      res.data.data.activity_info.end_time < now_timestamp
        ? '已结束'
        : res.data.data.activity_info.start_time > now_timestamp
        ? '未开始'
        : '进行中';
    this.activity_info = getActivityData(res.data.data.activity_info);
  }

  async created() {
    this.activity_id = this.$route.query.activity_id as string;
    await this.query();
    this.activity_item_list = getActivityItemList(
      this.moduleName.activity_config,
      this.activity_info,
    );
    const res = await this.$axios.get(API.get_setting_info);
    if (res.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    const remote = ((res || {}).data || {}).data || {};
    this.activity_item_list[0].value = remote.specify_ware_name || '指定商品';
  }
}
